import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  makeStyles,
} from "@material-ui/core";
import CustomTextField from "../../../common-components/CustomTextField";
import React, { useState, useEffect } from "react";
import { Select as AntSelect, Checkbox, Divider } from "antd";
import { AntSwitch } from "../../../common-components/AntSwitch";

const useStyles = makeStyles((theme) => ({
  formGrid: {
    marginBottom: "15px",
  },
  addDialog: {
    width: "500px",
    height: "auto",
    position: "relative",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    fontSize: "13px",
  },
  dropdown: {
    width: "100%",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  saveBtn: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px !important",
    textTransform: "none",
    border: "1px solid #3599d1",
    color: "#ffff",
    backgroundColor: "#0176d3",
    marginRight: "8px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
}));

export const CreateUserDialog = ({
  showDialog,
  setShowDialog,
  onCreateNewUser,
  roles,
  contracts,
}) => {
  const classes = useStyles();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [isFormValid, setisFormValid] = useState(false);
  const [contractAccess, setContractAccess] = useState(false);
  const [indirectAccess, setIndirectAccess] = useState(false);
  const [fringeAccess, setFringeAccess] = useState(false);
  const [pipelineAccess, setPipelineAccess] = useState(false);

  const onCreate = () => {
    onCreateNewUser({
      firstName,
      lastName,
      email,
      role,
      visibleContracts: selectedContracts,
      contractAccess,
      indirectAccess,
      fringeAccess,
      pipelineAccess,
      tempId: Date.now(),
      userId: 0,
    });
    setShowDialog(false);
  };

  const onChangeRole = (value) => {
    setRole(value);
  };

  useEffect(() => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setRole("");
    setSelectedContracts([]);
    setContractAccess(false);
    setIndirectAccess(false);
    setFringeAccess(false);
    setPipelineAccess(false);
    return () => {};
  }, [showDialog]);

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  useEffect(() => {
    setisFormValid(
      firstName.length &&
        lastName.length &&
        isValidEmail(email) &&
        role.length &&
        selectedContracts.length,
    );
  }, [firstName, lastName, email, role, selectedContracts]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedContracts(contracts.map((c) => c.value));
    } else {
      setSelectedContracts([]);
    }
  };

  const allSelected = selectedContracts.length === contracts.length;

  return (
    <div>
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="lg"
        aria-labelledby="confirmation-dialog"
        open={showDialog}
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span
              className={classes.closeIconAdd}
              onClick={() => setShowDialog(false)}
            >
              x
            </span>
            <div className={classes.addColumnTitle}>Create New User</div>
          </div>
          <Grid container spacing={2}>
            <Grid
              item
              lg={6}
              spacing={2}
              className={classes.formGrid}
              style={{ flex: 1 }}
            >
              <div className={classes.fieldTitle}>
                First Name{" "}
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={firstName}
                onChangeItem={(e) => setFirstName(e.target.value)}
                id="firstName"
                itemWidth="100%"
              />
            </Grid>{" "}
            <Grid
              item
              lg={6}
              spacing={2}
              className={classes.formGrid}
              style={{ flex: 1 }}
            >
              <div className={classes.fieldTitle}>
                Last Name{" "}
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={lastName}
                onChangeItem={(e) => setLastName(e.target.value)}
                id="lastName"
                itemWidth="100%"
              />
            </Grid>{" "}
          </Grid>
          <Grid container spacing={2} lg={12}>
            <Grid
              item
              lg={6}
              spacing={2}
              className={classes.formGrid}
              style={{ flex: 1 }}
            >
              <div className={classes.fieldTitle}>
                Email <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={email}
                onChangeItem={(e) => setEmail(e.target.value)}
                id="email"
                itemWidth="100%"
                type="email"
              />
            </Grid>{" "}
            <Grid
              item
              lg={6}
              spacing={2}
              className={classes.formGrid}
              style={{ flex: 1 }}
            >
              <div className={classes.fieldTitle}>
                Role <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <AntSelect
                className={classes.dropdown}
                value={role}
                onChange={(value) => onChangeRole(value)}
              >
                {roles.map((role, index) => (
                  <Option key={index} value={role.role}>
                    {role.roleDescription}
                  </Option>
                ))}
              </AntSelect>
            </Grid>
          </Grid>
          <Grid item className={classes.formGrid} style={{ flex: 1 }}>
            <div className={classes.fieldTitle}>
              Visible Contracts
              <span style={{ color: "red", marginLeft: "4px" }}>*</span>
            </div>
            <AntSelect
              showSearch
              mode="multiple"
              size="small"
              style={{ width: "100%", zIndex: 9 }}
              placeholder="Search to Select"
              showArrow
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label.toLowerCase() ?? "").includes(
                  input.toLowerCase(),
                )
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              dropdownRender={(menu) => (
                <>
                  <div style={{ padding: "8px 12px" }}>
                    <Checkbox onChange={handleSelectAll} checked={allSelected}>
                      Select All
                    </Checkbox>
                  </div>
                  <Divider style={{ margin: "4px 0" }} />
                  {menu}
                </>
              )}
              maxTagCount={5}
              options={contracts}
              value={selectedContracts}
              onChange={(val) => {
                setSelectedContracts(val);
              }}
            />
          </Grid>
          <Grid container spacing={2} style={{ marginTop: "8px" }}>
            <Grid item>
              <Checkbox
                checked={contractAccess}
                onChange={(e) => setContractAccess(e.target.checked)}
              >
                Contract Access
              </Checkbox>
            </Grid>
            <Grid item>
              <Checkbox
                checked={indirectAccess}
                onChange={(e) => setIndirectAccess(e.target.checked)}
              >
                Indirect Access
              </Checkbox>
            </Grid>
            <Grid item>
              <Checkbox
                checked={fringeAccess}
                onChange={(e) => setFringeAccess(e.target.checked)}
              >
                Fringe Access
              </Checkbox>
            </Grid>
            <Grid item>
              <Checkbox
                checked={pipelineAccess}
                onChange={(e) => setPipelineAccess(e.target.checked)}
              >
                Pipeline Access
              </Checkbox>
            </Grid>
          </Grid>
          <div className={classes.popupBtnsAdd}>
            <Button
              disabled={!isFormValid}
              className={classes.saveBtn}
              variant="contained"
              color="primary"
              onClick={() => onCreate()}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              onClick={() => setShowDialog(false)}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
